exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/indigo-pink.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\n.cdk-overlay-container {\r\n  z-index:1127;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles